import React from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";

const Contact = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEO
        title="Contact Us"
        description="Get in touch with Trademark Facility. Call +1 (877) 405-0574 or visit us at 340 E Middlefield Rd, Mountain View, CA 94043 for a free consultation."
        path="/contact"
        keywords="contact trademark attorney, free consultation, trademark registration help"
      />
      {/* Hero Section */}
      <section className="relative bg-[#07382f] overflow-hidden text-white py-12 md:py-20">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="font-heading text-3xl md:text-5xl font-extrabold tracking-tight mb-4 md:mb-6">
              Contact Us
            </h1>
            <p className="text-sm sm:text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">
              Get in touch with our expert team. We're here to help protect your
              intellectual property and answer all your questions.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-12 md:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {/* Contact Information */}
            <div className="min-w-0 order-2 md:order-1">
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#2d3132] mb-4 md:mb-6">
                Get in Touch
              </h2>
              <p className="text-sm sm:text-lg text-gray-600 mb-6 md:mb-8">
                Have questions about our services? Want to discuss your
                trademark needs? Our team is ready to assist you.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-lime/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="h-6 w-6 text-lime" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2d3132] mb-1">
                      Office Address
                    </h3>
                    <p className="text-gray-600">
                      340 E Middlefield Rd,
                      <br />
                      Mountain View, CA 94043
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-lime/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="h-6 w-6 text-lime" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2d3132] mb-1">
                      Phone Number
                    </h3>
                    <p className="text-gray-600">
                      Toll-Free: +1 (877) 405-0574
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-lime/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <Mail className="h-6 w-6 text-lime" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2d3132] mb-1">
                      Email Address
                    </h3>
                    <p className="text-gray-600">info@trademarkfacility.com</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-lime/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="h-6 w-6 text-lime" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2d3132] mb-1">
                      Business Hours
                    </h3>
                    <p className="text-gray-600">
                      Monday - Friday: 9:00 AM - 6:00 PM EST
                      <br />
                      Saturday: 10:00 AM - 4:00 PM EST
                      <br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="min-w-0 order-1 md:order-2">
              <ContactForm
                title="Send Us a Message"
                buttonText="Send Message"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
